import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import AeroponicsApp from './App';
import * as serviceWorker from './serviceWorker';

// Importing the Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render((
    <BrowserRouter>
        <AeroponicsApp />
    </BrowserRouter>
), document.getElementById('aeroponicsCalcApp'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
